import renderRejectRentingModal from "../../../infrastructure/renders/RejectRentingModal/render-reject-renting-modal";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { denyRequest } from "../../../infrastructure/repository/request-repository";
import { translate } from "../../../infrastructure/translate/localization";
import { hideModal } from "../../commons/hide-modal";
import { showSuccessMessage } from "../../commons/show-success-message";
import { displayRequestsPage } from "../display-requests-page";

export default async function denyRentingRequest({ requestId }) {
  const companyId = await findCompanyId();
  renderRejectRentingModal({
    callback: async ({ rejectionReason }) => {
      renderRejectRentingModal({
        isLoading: true,
        defaultMessage: rejectionReason,
      });
      await denyRequest({
        companyId,
        rejectionReason,
        requestId,
        category: "renting-benefit",
      });
      hideModal();
      showSuccessMessage(
        translate("employees-section.renting-request-denied-successfully")
      );
      displayRequestsPage({ selectedTab: "renting" });
    },
  });
}
